import createTheme from '@mui/material/styles/createTheme';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2864AC',
    },
    secondary: {
      main: '#5182BB',
    },
    success: {
      main: '#7EC141',
      contrastText: '#ffffff',
    },
    text: {
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
    error: {
      main: '#E54D39',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          label: {
            color: '#2864AC',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'E0E0E0',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: '#ffffff',
            opacity: 0.38,
          },
          borderRadius: 20,
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#8D8D8D',
          '&.Mui-active': {
            color: '#2864AC',
          },
          '&.Mui-completed': {
            color: '#7EC141',
          },
          zIndex: 1,
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          '&.Mui-active': {
            color: '#2864AC',
          },
          '&.MuiStepLabel-alternativeLabel': {
            marginTop: '4px',
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          '&.Mui-active': {
            backgroundColor: '#2864AC',
          },
          '&.Mui-disabled': {
            backgroundColor: '#8D8D8D',
          },
        },
        lineHorizontal: {
          height: 3,
          border: 0,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: ({ ownerState }) => ({
          color:
            ownerState.focused || ownerState.filled ? 'inherit' : '#E54D39',
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#7EC141',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          textAlign: 'start',
        },
      },
    },
  },
});
